// extracted by mini-css-extract-plugin
module.exports = {"bodyTypeFilter":"BodyTypeFilter_bodyTypeFilter__0JgGG","listItem":"BodyTypeFilter_listItem__jl0eE","icon":"BodyTypeFilter_icon__YVmbl"};